import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Wrapper,
  Title,
  Grid,
  Card,
  CardImage,
  CardBody,
  CardFooter,
  BusinessTitle,
  BusinessInfo,
  BusinessContact,
  BusinessButton,
  LearnMoreLink,
  ImageModalOverlay,
  ModalContent,
  ModalImage,
  ModalClose,
} from "./Businesses.styles";
import businessData from "../../data/businesses";

const Businesses = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedAlt, setSelectedAlt] = useState("");

  const openLightbox = (src, alt) => {
    setSelectedImage(src);
    setSelectedAlt(alt);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setSelectedAlt("");
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      closeLightbox();
    }
  };

  return (
    <Wrapper id="businesses">
      <Title>
        Our <span>Businesses</span>
      </Title>
      <Grid>
        {businessData.map((biz) => (
          <Card key={biz.id}>
            <CardImage onClick={() => openLightbox(biz.image, biz.title)}>
              <img src={biz.image} alt={biz.title} />
            </CardImage>
            <CardBody>
              <BusinessTitle>{biz.title}</BusinessTitle>
              <BusinessInfo>{biz.info}</BusinessInfo>
              <CardFooter>
                {biz.contact && <BusinessContact>{biz.contact}</BusinessContact>}
                {biz.path && (
                  <LearnMoreLink as={Link} to={biz.path}>Learn more</LearnMoreLink>
                )}
                {biz.isButton && (
                  <BusinessButton
                    href={biz.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit Store
                  </BusinessButton>
                )}
              </CardFooter>
            </CardBody>
          </Card>
        ))}
      </Grid>

      {selectedImage && (
        <ImageModalOverlay onClick={handleOverlayClick}>
          <ModalContent>
            <ModalClose onClick={closeLightbox} aria-label="Close image preview">
              ×
            </ModalClose>
            <ModalImage src={selectedImage} alt={selectedAlt} />
          </ModalContent>
        </ImageModalOverlay>
      )}
    </Wrapper>
  );
};

export default Businesses;
